import { createFileRoute } from "@tanstack/react-router";
import { PortalApp } from "./public.reports.$token";

// URL pública limpia del portal de transparencia por slug de cliente: /r/{slug}.
// Reusa el portal; el backend resuelve el slug igual que un token público.
export const Route = createFileRoute("/r/$slug")({
  component: SlugPortal,
});

function SlugPortal() {
  const { slug } = Route.useParams();
  return <PortalApp token={slug} />;
}
